/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const ALL_OPTION = "All";
